<template>
    <div class="Video">
        <div
            v-if="!clickedVideo"
            class="still embed"
            :style="`background-image: url(${imageUrl})`"
            @click="playVideo"
        >
            <div class="playBtn">
                <Icon name="play"/>
            </div>
        </div>
        <div v-else class="embed">
            <iframe
                :src="src"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
                autoplay
            ></iframe>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Video',

    data: () => ({
        clickedVideo: false,
    }),

    props: {
        videoId: { type: String, required: true  },
        bgImage: { type: String, default: undefined },
        playInNewTab: { type: Boolean, default: false },
    },

    computed: {
        src() {
            return `https://www.youtube.com/embed/${this.videoId}?autoplay=true&rel=0`;
        },

        imageUrl() {
            const ytThumbnail = `http://img.youtube.com/vi/${this.videoId}/sddefault.jpg`
            return this.bgImage ?? ytThumbnail;
        }
    },

    methods: {
        playVideo() {
            if (this.playInNewTab) {
                const url = `https://www.youtube.com/watch?v=${this.videoId}`;
                return window.open(url, '_blank');
            }

            this.clickedVideo = true;
        },
    },
};
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.Video {
    width: 100%;

    .embed {
        @include aspect-ratio(16, 9);
        width: 100%;
    }

    .still {
        background-size: cover;
        background-position: center;
        cursor: pointer;

        &:hover .playBtn {
            background-color: #000;
        }

        .playBtn {
            @include aspect-ratio(1, 1);
            @include absolute-center();
            width: 80px;
            z-index: 2;
            border-radius: 50%;
            background-color: $link-color;
            transition: background-color 250ms ease-out;

            .Icon {
                @include absolute-center();
                color: #fff;
                font-size: 28px;
                margin-left: 2px;
            }
        }
    }

    iframe  {
        @include overlay();
    }
}
</style>
